// KLA-016 crisis / self-harm safety net.
//
// A high-recall, client-side detector plus a tiny global pub/sub so any Klair
// surface can raise a prominent support intervention INSTANTLY, without waiting
// on the backend. This is a safety net in addition to the server-side distress
// handling. IMPORTANT: the trigger list and the copy shown to the user should be
// reviewed and signed off by a qualified clinical / compliance authority before
// this is relied upon in production. It is deliberately tuned to catch explicit
// self-harm and suicidal-ideation language; it does not fire on a bare "sad" or
// "depressed" to avoid mislabeling ordinary assessment answers.

const CRISIS_PATTERNS = [
  /\bsuicid/i,
  /\bkill(ing)?\s+my\s?self\b/i,
  /\bend(ing)?\s+(my|it)\s+(life|all)\b/i,
  /\btake\s+my\s+(own\s+)?life\b/i,
  /\b(want|going|plan\w*)\s+to\s+die\b/i,
  /\b(do\s?n'?t|no longer)\s+want\s+to\s+(live|be here|exist)\b/i,
  /\bno\s+(reason|point)\s+(to|in)\s+(living|live|go\s?on|going on)\b/i,
  /\bbetter\s+off\s+dead\b/i,
  /\b(hurt|harm|cut(ting)?)\s+my\s?self\b/i,
  /\bself[\s-]?harm/i,
  /\bcan'?t\s+(go on|do this|take it)\b.*\b(anymore|any more)\b/i,
  /\bwish\s+I\s+(was|were)\s+(dead|not here|gone)\b/i,
];

export function detectCrisis(text) {
  if (!text || typeof text !== "string") return false;
  return CRISIS_PATTERNS.some((re) => re.test(text));
}

const listeners = new Set();
export function onCrisis(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}
export function raiseCrisis(reason) {
  listeners.forEach((cb) => { try { cb(reason || "detected"); } catch (_e) { /* never let a listener break safety */ } });
}
// Check text, raise the overlay if it looks like a crisis, and report whether it did.
export function guardCrisis(text) {
  if (detectCrisis(text)) { raiseCrisis("client"); return true; }
  return false;
}
